export function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-3xl font-bold text-navy mb-2">Privacy Policy</h1>
      <p className="text-sm text-navy-500 mb-10">
        Last updated: {new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' })}
      </p>

      <Section title="What we collect">
        <ul className="list-disc pl-5 space-y-1">
          <li>Account information: email, name, phone, profile photo.</li>
          <li>Listing data: trailer details, photos, pickup location, pricing.</li>
          <li>Booking data: dates, payments, messages between renter and owner.</li>
          <li>Verification: a yes/no signal from Stripe Identity. We don't store IDs.</li>
          <li>Payment data: handled by Stripe. We never see full card numbers.</li>
          <li>Usage analytics: page views, click events. No third-party ad networks.</li>
        </ul>
      </Section>

      <Section title="How we use it">
        <ul className="list-disc pl-5 space-y-1">
          <li>Run the marketplace — show listings, process bookings, send notifications.</li>
          <li>Trust &amp; safety — match listings, prevent fraud, handle disputes.</li>
          <li>Improve the product — aggregate, de-identified usage analytics.</li>
          <li>Comply with the law — tax, legal requests, anti-fraud obligations.</li>
        </ul>
      </Section>

      <Section title="Who we share with">
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Stripe</strong> — payments, payouts, Identity verification.</li>
          <li><strong>SendGrid</strong> — transactional emails.</li>
          <li><strong>Mapbox</strong> — geocoding and map tiles.</li>
          <li><strong>AWS</strong> — Aurora (database), S3 (photos), Fargate (hosting).</li>
          <li>Other users — to the extent they need to identify and contact you for a booking.</li>
        </ul>
        <p className="mt-3">We don't sell your data. We don't share it with ad networks.</p>
      </Section>

      <Section title="Your rights">
        <p>
          You can view, export, or delete your account at any time from{' '}
          <a href="/account" className="text-orange hover:underline">/account</a>. Deletion is
          permanent — past bookings may be retained in anonymized form for tax and audit purposes.
        </p>
      </Section>

      <Section title="Contact">
        <p>
          <a className="text-orange hover:underline" href="mailto:privacy@towshare.ca">privacy@towshare.ca</a>
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8 text-navy-700">
      <h2 className="text-xl font-semibold text-navy mb-2">{title}</h2>
      {children}
    </section>
  );
}
